export default "__VITE_ASSET__DTnPkc_B__"